import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DocumentsComponent } from './documents.component';
import { SharedModule } from '../../../shared/shared.module';
import { FeatureSwitchGuard } from '../../../shared/guards/feature-switch.guard';
import { FeatureSwitch } from '../../../shared/data/feature-switch';
import { DocumentsAccessComponent } from './documents-access/documents-access.component';
import { sessionResolver } from '../../../api/session/session.resolver';
import { latestTaxYearResolver } from './tax-documents/latest-tax-year.resolver';
import { taxDocumentCustomersResolver } from './tax-documents/tax-document-customers.resolver';
import { TaxDocumentsGuard } from '../../../shared/guards/tax-documents.guard';

const statementsAndTaxFormsRoute: Routes = [
  {
    path: '',
    component: DocumentsComponent,
    resolve: {taxDocumentCustomers: taxDocumentCustomersResolver},
    children: [
      {
        path: 'statements',
        loadChildren: () => import('./statements/statements.module').then(m => m.StatementsModule),
        resolve: {userSession: sessionResolver},
        canActivate: [FeatureSwitchGuard],
        data: {
          featureSwitches: [FeatureSwitch.STATEMENTS, FeatureSwitch.CDARS_STATEMENTS],
          mode: 'any'
        }
      },
      {
        path: 'notices',
        loadChildren: () => import('./notices/notices.module').then(m => m.NoticesModule),
        resolve: {userSession: sessionResolver},
        canActivate: [FeatureSwitchGuard],
        data: {
          featureSwitches: [FeatureSwitch.CDARS_STATEMENTS],
          mode: 'all'
        }
      },
      {
        path: 'tax-documents',
        loadChildren: () => import('./tax-documents/tax-documents.module').then(m => m.TaxDocumentsModule),
        resolve: {
          userSession: sessionResolver,
          latestTaxYear: latestTaxYearResolver
        },
        canActivate: [FeatureSwitchGuard, TaxDocumentsGuard],
        data: {
          featureSwitches: [FeatureSwitch.ICS_TAX_DOCUMENTS, FeatureSwitch.CDARS_TAX_DOCUMENTS],
          mode: 'any'
        }
      },
      {
        path: '',
        component: DocumentsAccessComponent,
        resolve: {userSession: sessionResolver},
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
    imports: [
        RouterModule.forChild(statementsAndTaxFormsRoute),
        SharedModule,
        DocumentsComponent,
        DocumentsAccessComponent
    ],
    exports: [RouterModule]
})
export class DocumentsModule {
}